
export default function CircleLoader() {
    return <div className={'container mx-auto loader mt-4'}></div>
}